import React, { useEffect, useState } from "react";
import { fetchHtml } from "../../lib/Fetching";
import moment from "moment";

export default function SampleSummaryView({ id, simpleView = false, clientView = false }) {
  const [html, setHtml] = useState("");

  useEffect(
    () => {
      setHtml("");
      const url = clientView
        ? `/client/samples/${id}/summary`
        : `/laboratory/samples/${id}/summary`;
      fetchHtml(url, { simple_view: simpleView }).then(
        (html) => setHtml(html)
      );
    },
    [id, clientView, simpleView]
  );

  return (
    <div>
      {!html && <i className="fa fa-spinner fa-spin" />}
      <div dangerouslySetInnerHTML={{ __html: html }} />
    </div>
  );
}
